<template>
  <loading-message
      v-if="message.status === 'loading'"
      :message="message"></loading-message>
  <error-message
      v-else-if="message.status === 'network-error'"
      :message="message"></error-message>
  <group-end-message
      v-else-if="message.id === -200"
      :message="message"></group-end-message>
  <text-message
      v-else-if="message.type === MessageType.TEXT"
      :message="message"></text-message>
  <output-message
      v-else-if="message.type === MessageType.OUTPUT"
      :message="message"></output-message>
  <code-message
      v-else-if="message.type === MessageType.CODE && message.data.type === 'browser'"
      :message="message"></code-message>
  <oj-code-message
      v-else-if="message.type === MessageType.CODE && message.data.type === 'oj'"
      :message="message"></oj-code-message>
  <image-message
      v-else-if="message.type === MessageType.IMAGE"
      :message="message"></image-message>
  <choice-message
      v-else-if="message.type === MessageType.CHOICE"
      :message="message"></choice-message>
  <file-message
      v-else-if="message.type === MessageType.FILE"
      :message="message"></file-message>
  <video-message
      v-else-if="message.type === MessageType.VIDEO"
      :message="message"></video-message>
  <test-message
      v-else-if="message.type === MessageType.TEST"
      :message="message"></test-message>
  <quick-select-message
      v-else-if="message.type === MessageType.QUICK_SELECT"
      :message="message"></quick-select-message>
  <quick-choices-message
      v-else-if="message.type === MessageType.QUICK_CHOICES"
      :message="message"></quick-choices-message>
  <match-user-message
      v-else-if="message.type === MessageType.MATCH_USER"
      :message="message"></match-user-message>
  <programming-message
      v-else-if="message.type === MessageType.PROGRAMMING"
      :message="message"></programming-message>
  <system-message
      v-else-if="message.type === MessageType.SYS"
      :message="message"></system-message>
  <pk-message
      v-else-if="message.type === MessageType.PK"
      :message="message"></pk-message>
  <notice-message
      v-else-if="message.type === MessageType.NOTICE"
      :message="message"></notice-message>
  <branch-message
      v-else-if="message.type === MessageType.BRANCH"
      :message="message"></branch-message>
  <checkpoint-message
      v-else-if="message.type === MessageType.CHECKPOINT"
      :message="message"></checkpoint-message>
  <checkpoints-message
      v-else-if="message.type === MessageType.CHECKPOINTS"
      :message="message"></checkpoints-message>
</template>

<script>
import { MessageType } from '../lib/Message'
import ErrorMessage from './ErrorMessage'
import TextMessage from './TextMessage'
import OutputMessage from './OutputMessage'
import CodeMessage from './CodeMessage'
import ChoiceMessage from './ChoiceMessage'
import ImageMessage from './ImageMessage'
import FileMessage from './FileMessage'
import TestMessage from './TestMessage'
import LoadingMessage from './LoadingMessage'
import VideoMessage from '@/components/classroom/messages/VideoMessage'
import QuickSelectMessage from '@/components/classroom/messages/QuickSelectMessage'
import QuickChoicesMessage from '@/components/classroom/messages/QuickChoicesMessage'
import OjCodeMessage from '@/components/classroom/messages/OjCodeMessage'
import MatchUserMessage from '@/components/classroom/messages/MatchUserMessage'
import ProgrammingMessage from '@/components/classroom/messages/ProgrammingMessage'
import SystemMessage from '@/components/classroom/messages/SystemMessage'
import GroupEndMessage from '@/components/classroom/messages/GroupEndMessage'
import PkMessage from '@/components/classroom/messages/PkMessage'
import NoticeMessage from '@/components/classroom/messages/NoticeMessage'
import BranchMessage from '@/components/classroom/messages/BranchMessage'
import CheckpointMessage from '@/components/classroom/messages/CheckpointMessage'
import CheckpointsMessage from '@/components/classroom/messages/CheckpointsMessage'

export default {
  components: {
    BranchMessage,
    NoticeMessage,
    PkMessage,
    GroupEndMessage,
    ProgrammingMessage,
    MatchUserMessage,
    CheckpointMessage,
    CheckpointsMessage,
    QuickSelectMessage,
    QuickChoicesMessage,
    VideoMessage,
    SystemMessage,
    TextMessage,
    OutputMessage,
    ChoiceMessage,
    CodeMessage,
    OjCodeMessage,
    ImageMessage,
    LoadingMessage,
    ErrorMessage,
    FileMessage,
    TestMessage
  },
  props: { 'message': {}, 'left': { default: true }, 'course': {} },
  data () {
    return {
      MessageType: MessageType
    }
  }
}
</script>
